import { Box } from "../box/Box";
import { RecursiveCSS } from "../theme/GlobalTheme";
import { V2 } from "../theme/DesignV2";

export const Tile = ({ children, sx, onClick }: { children: any; sx?: RecursiveCSS; onClick?: () => void }) => {
	return (
		<Box data-surface="tile"
			sx={{
				backgroundColor: "panelBackgroundPrimary",
				borderRadius: V2.surfaceRadius,
				padding: V2.spacing,
				border: `1px solid ${V2.border}`,
				boxShadow: V2.shadow,
				...sx,
			}}
			onClick={onClick}>
			{children}
		</Box>
	);
};
